var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"#f5f5f5","min-height":"100%"}},[_c('ListPageTemplate',_vm._b({attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-col',{staticClass:"py-0 px-1 px-sm-3 mt-6 mt-md-10",attrs:{"cols":"6","md":"4"}},[_c('ArticleCard',_vm._b({},'ArticleCard',item,false))],1)]}}])},'ListPageTemplate',_vm.settings,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }